import { render } from "./LanguageStatisticsChart.vue?vue&type=template&id=3ac34bfc&ts=true"
import script from "./LanguageStatisticsChart.vue?vue&type=script&lang=ts"
export * from "./LanguageStatisticsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__